import { createGlobalStyle, css } from 'styled-components'
import { withTheme } from 'styled-components'

import { defaultFontFamily } from '@/theme/typography.js'
import 'react-phone-input-2/lib/style.css'

const Global = createGlobalStyle`
    ${({ theme }) => {
        const { typography, palette } = theme

        return css`
            html,
            body,
            #root {
                font-family: ${defaultFontFamily};
                color: ${palette.neutral.base[1000]};
                background-color: ${palette.neutral.base[0]};
            }

            h1 {
                ${typography.heading1};
            }

            h2 {
                ${typography.heading2};
            }

            h3 {
                ${typography.heading3};
            }

            h4 {
                ${typography.heading4};
            }

            a {
                cursor: pointer;
                text-decoration: underline;
                color: ${palette.neutral.base[1000]};
                ${typography.paragraph.p14.regular};

                &:hover {
                    color: ${palette.primary.base.active};
                }
            }
        `
    }}
`

export default withTheme(Global)
